import React, { useMemo } from 'react'
import HydroProcessScreen from './HydroProcess'
import HydroEvents from './HydroEvents'
import { Route } from 'react-router-dom'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

export const HydroContainer = ({ actionPermits, envConfig }) => {
  const eventHydro = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.HYDRO_VIEW,
          ScreenPermissions.HYDRO_ADD_DATA,
          ScreenPermissions.HYDRO_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const processHydro = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.HYDRO_PROCESS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {eventHydro && (
        <Route exact path="/breaker-events" component={HydroEvents} />
      )}
      {processHydro && (
        <Route exact path="/breaker-process" component={HydroProcessScreen} />
      )}
    </React.Fragment>
  )
}
